import { Dropdown, Form, Input, Menu, Message, Spin, Tooltip, Tree } from '@arco-design/web-react'
import { IconDriveFile, IconMore, IconMoreVertical, IconPlusCircle, IconSearch } from '@arco-design/web-react/icon'
import "./FolderList.less"
import React, { useEffect, useRef, useState } from 'react'
import floderImg from "@/assets/create-space/folder-yellow.png";
import {
  IGetMaterialSearch,
  getMetarialData,
} from "@/services/createSpace/graphQ/getMetarialList";
import ActionBar from "@/pages/CreationSpace/components/ActionBar/ActionBar";
import ActionBarItem from "@/pages/CreationSpace/components/ActionBar/ActionBarItem";
import { deleteMaterial, getAllMaterialFolders, moveFileAndFolder } from '@/services/createSpace/material';
import CreateFolderModal from '../../SearchOpeator/CreateFolderModal/CreateFolderModal';
import useCopyMaterialsAndFolders from '@/requestHooks/createSpace/material/useCopyMaterialsAndFolders';
import RemoveTipModal from '../../RemoveTipModal/RemoveTipModal';
import { debounce } from "lodash";
import RenameModal from './RenameModal';

export default function FolderList({ projectId, onFolderClick, folderId }) {
  const [treeData, setTreeData] = useState([])
  const [loading, setLoading] = useState(false)
  const [folderName, setFolderName] = useState(null)
  const { handleCopyFile } = useCopyMaterialsAndFolders();
  const [deleteVisible, setDeleteVisible] = useState(false)
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [renameVisible, setRenameVisible] = useState(false);
  const treeDataRef = useRef([])
  const getTreeData = async(init = false) => {
    setLoading(true)
    const res = await getAllMaterialFolders({project_id: projectId});
    const folders = res?.items || []
    const firstList = folders.filter(i => !i.parent_id)
    const hasParentList = folders.filter(i => i.parent_id)
    const result = firstList.map(item => {
      const children = hasParentList.filter(i => i.parent_id === item.id)?.map(i => ({...i, ischildren: true}))
      item.children = children || []
      return item
    })
    setTreeData([{id: 0, name:'全部', project_id: projectId},...result])
    treeDataRef.current = [{id: 0, name:'全部', project_id: projectId},...result]
    if (init) {

    }
    setLoading(false)
  }
  const [createVisible, setCreateVisible] = useState(false)
  useEffect(() => {
    if (projectId) getTreeData(true)
  }, [projectId])
  const onClickMenuItem = async (key, node) => {
    if (key === '1') {
      setFolderName(node.name)
      setCreateVisible(true)
    } else if (key === '2') {
      setRenameVisible(true);
      setEditId(node.id)
      renameForm.setFieldValue('folderName', node.name)
    } else if (key === '3') {
      setLoading(true)
      if (loading) return
      try {
        await handleCopyFile(node.id, projectId);
        getTreeData()
      } catch (e) {
        Message.error(e)
      }
    } else if (key === '4') {
      setDeleteVisible(true)
      setEditId(node.id)
    }
  }
  const [editId, setEditId] = useState(null)
  const deleteBatchOrBatch = debounce(async (state: boolean) => {
    try {
      setConfirmLoading(true)
      await deleteMaterial(editId, state);
      setEditId(null);
      setConfirmLoading(false)
      getTreeData()
    } catch (e) {
      setConfirmLoading(false)
      Message.error(e);
    } finally {
      setDeleteVisible(false);
    }
  }, 500);
  const handleRenameOk = () => {
    getTreeData()
    setRenameVisible(false)
  }
  const [renameForm] = Form.useForm()
  const [selectedKeys, setSelectedKeys] = useState([])
  const handleClick = () => {
    setFolderName(null)
    setCreateVisible(true)
  }
  function searchData(inputValue) {
    const loop = (data) => {
      const result = [];
      data.forEach((item) => {
        if (item.name.indexOf(inputValue) > -1) {
          result.push({ ...item });
        } else if (item.children) {
          const filterData = loop(item.children);

          if (filterData.length) {
            result.push({ ...item, children: filterData });
          }
        }
      });
      return result;
    };
    return loop([...treeDataRef.current]);
  }
  useEffect(() => {
    if (folderId){
      setSelectedKeys([folderId])
    } else {
      setSelectedKeys([0])
    }
  }, [folderId])
  const [inputValue, setInputValue] = useState('')
  useEffect(() => {
    if (!inputValue) {
      setTreeData([...treeDataRef.current]);
    } else {
      const result = searchData(inputValue);
      setTreeData(result);
    }
  }, [inputValue]);
  return (
    <div className="material-folder-list">
      <div className="header-area">
        <h4>文件夹</h4>
        <Tooltip content='新建文件夹'>
          <IconPlusCircle style={{ fontSize: '18px', cursor: 'pointer'}} onClick={handleClick} />
        </Tooltip>
      </div>
      <div style={{ margin: '5px 0 10px 0' }}>
        <Input prefix={<IconSearch />} placeholder='请输入关键字' value={inputValue} onChange={e => setInputValue(e || '')}></Input>
      </div>
      <div className="tree-area">
        <Spin loading={loading} style={{ width: '100%' }}>
        <Tree
          style={{ width: '100%' }}
          fieldNames={{
            key: 'id',
            title: 'name'
          }}
          treeData={treeData}
          draggable
          selectedKeys={selectedKeys}
          icons={{
            dragIcon: null
          }}
          renderTitle={(props: any) => {
            return <span style={{ display: 'flex', alignItems: 'center', position: 'relative'}} onClick={() => {
              setSelectedKeys([props.id || 0])
              onFolderClick({...props.dataRef, isLeaf: props.isChildren, parentData: treeData.find(i => i.id === props.parent_id)})
            }}>
              <div className="folder-img" style={{position: 'absolute', top: '-5px', height: '32px', display: 'flex', alignItems: 'center' }}>
                <img style={{ width: '14px', height: '14px', cursor: 'pointer' }} src={floderImg} alt="" />
              </div>
              <span style={{ cursor: 'pointer', display: 'inline-block', width: '140px', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>{props.title}</span>
            </span>
          }}
          onDrop={({ dragNode, dropNode, dropPosition }: any) => {
            if (!dragNode.props.id) {
              Message.error('全部无法移动')
            }
            if (dropPosition === 0) {
              setLoading(true)
              moveFileAndFolder({
                ids: [dragNode.props.id] as number[],
                targetParentId: dropNode.props.id,
                projectId
              }).then(() => {
                getTreeData()
              }).finally(() => {
                setLoading(false)
              })
            }
          }}
          renderExtra={(node: any) => {
            return node.id ? (
              <div style={{ display: 'flex', alignItems: 'center', height: '32px' }}>
                <Dropdown droplist={(
                  <div style={{ background: '#fff'}}>
                    <ActionBar>
                    {node.parentKey ? null : <ActionBarItem
                      text={'新增子文件夹'}
                      onClick={() => {
                        onClickMenuItem('1', node)
                      }}
                    />}
                    <ActionBarItem
                      text={'重命名'}
                      onClick={() => {
                        onClickMenuItem('2', node)
                      }}
                    />
                    <ActionBarItem
                      text={'复制'}
                      onClick={() => {
                        onClickMenuItem('3', node)
                      }}
                    />
                    <ActionBarItem
                      text={'删除'}
                      onClick={() => {
                        onClickMenuItem('4', node)
                      }}
                    />
                  </ActionBar>
                  </div>
                )} position='bl'>
                  <div className="more">
                    <IconMore />
                  </div>
                </Dropdown>
              </div>
            ) : null
          }}
        ></Tree>
        </Spin>
      </div>
      {createVisible && <CreateFolderModal
        projectId={projectId}
        handleOnBtnClick={() => {
          getTreeData()
          setCreateVisible(false);
        }}
        onCancel={() => {
          setCreateVisible(false);
        }}
        visible={createVisible}
        folderName={folderName}
      />}
      {deleteVisible ? (
        <RemoveTipModal
          confirmLoading={confirmLoading}
          visible={deleteVisible}
          title={"删除提示"}
          handleDeleteBtnClick={async () => {
            deleteBatchOrBatch(true);
          }}
          handleHiddenDeleteBtnClick={async () => {
            deleteBatchOrBatch(false);
          }}
          onCancel={() => {
            setDeleteVisible(false);
          }}
        />
      ) : (
        <></>
      )}
      <RenameModal form={renameForm} editId={editId} visible={renameVisible} onOk={handleRenameOk} cancel={() => setRenameVisible(false)}/>
    </div>
  )
}
